/* eslint-disable arrow-parens */
/* eslint-disable prettier/prettier */
import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers, ADMIN_ENV } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { Authorization, Bearer } = AUTHORIZATION;
const { post, get, put, del } = request;

//http://14.96.189.251:4000/api/v1/find-email/?email=email@email.com&role=EMPLOYEE
export const findEmail = async (params) => {
	try {
		const endpoint = "find-email";
		const response = await get(endpoint, {}, params);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "Email doesnot exists!") {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Email is required!") {
				alert("Email is required!");
			} else if (message === "Role is required!") {
				alert("Role is required!");
			} else if (message === "Email already exists!") {
				alert("Email already exists!");
			} else if (message === "Unauthorized Role!") {
				alert("Unauthorized Role!");
			} else if (message === "Finding email error!") {
				alert("Finding email error!");
			} else if (message === MESSAGE.get.fail) {
				if (ADMIN_ENV == "DEV") {
					console.log("Failed to fetch data");
				} else {
					alert("Failed to fetch data");
				}
			} else {
				if (ADMIN_ENV == "DEV") {
					console.log("Failed to fetch data");
				} else {
					alert("Failed to fetch data");
				}
			}
		} else {
			throw error;
		}
	}
};

//http://14.96.189.251:4000/api/v1/find-member-email/:email
export const findMemberEmail = async (findEmailQuery) => {
	try {
		const endpoint = "find-member-email";
		const response = await get(endpoint, {}, findEmailQuery);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "Email doesnot exists!") {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Email is required!") {
				alert("Email is required!");
			} else if (message === "Email already exists!") {
				alert("Email already exists!");
			} else if (message === "Finding email error!") {
				alert("Finding email error!");
			} else if (message === MESSAGE.get.fail) {
				if (ADMIN_ENV == "DEV") {
					console.log("Failed to fetch data");
				} else {
					alert("Failed to fetch data");
				}
			} else {
				if (ADMIN_ENV == "DEV") {
					console.log("Failed to fetch data");
				} else {
					alert("Failed to fetch data");
				}
			}
		} else {
			throw error;
		}
	}
};

//http://14.96.189.251:4000/api/v1/find-user-email/:email
// eslint-disable-next-line arrow-parens
export const findGroupOwnerEmail = async (email) => {
	try {
		const endpoint = `find-group-owner-email/${email}`;
		const response = await get(endpoint);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "Email doesnot exists!") {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Email is required") {
				alert("Email is required");
			} else if (message === "Email already exists!") {
				alert("Email already exists!");
			} else if (message === "Finding email error!") {
				alert("Finding email error!");
			} else if (message === MESSAGE.get.fail) {
				if (ADMIN_ENV == "DEV") {
					console.log("Failed to fetch data");
				} else {
					alert("Failed to fetch data");
				}
			} else {
				if (ADMIN_ENV == "DEV") {
					console.log("Failed to fetch data");
				} else {
					alert("Failed to fetch data");
				}
			}
		} else {
			throw error;
		}
	}
};

//http://14.96.189.251:4000/api/v1/find-username/:user_name
export const findUserName = async (user_name) => {
	try {
		const endpoint = `find-username/${user_name}`;
		const response = await get(endpoint);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "User Name doesnot exists!") {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "User Name is required!") {
				alert("User Name is required!");
			} else if (message === "User Name already exists!") {
				alert("User Name already exists!");
			} else if (message === MESSAGE.get.fail) {
				if (ADMIN_ENV == "DEV") {
					console.log("Failed to fetch data");
				} else {
					alert("Failed to fetch data");
				}
			} else {
				if (ADMIN_ENV == "DEV") {
					console.log("Failed to fetch data");
				} else {
					alert("Failed to fetch data");
				}
			}
		} else {
			throw error;
		}
	}
};

// http://14.96.189.251:4000/api/v1/find-member-id/:member_id
export const findMemberId = async (findMemberIdQuery) => {
	try {
		const endpoint = "find-member-id";
		const response = await get(endpoint, {}, findMemberIdQuery);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "Member Id doesnot exists!") {
				const {
					data: { result }
				} = response;
				return result;
			} else if (message === "Member Id already exists!") {
				const {
					data: { result }
				} = response;
				alert("Member Id already exists!");
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log("Failed to fetch data");
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log("Failed to fetch data");
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			throw error;
		}
	}
};

//http://14.96.189.251:4000/api/v1/find-SSN/:SSN --> Not used right now
export const findSSN = async (SSN) => {
	try {
		const endpoint = `find-ssn/${SSN}`;
		const response = await get(endpoint);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "SSN doesnot exists!") {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "SSN is required") {
				alert("SSN is required");
			} else if (message === "SSN already exists!") {
				alert("SSN already exists!");
			} else if (message === MESSAGE.get.fail) {
				if (ADMIN_ENV == "DEV") {
					console.log("Failed to fetch data");
				} else {
					alert("Failed to fetch data");
				}
			} else {
				if (ADMIN_ENV == "DEV") {
					console.log("Failed to fetch data");
				} else {
					alert("Failed to fetch data");
				}
			}
		} else {
			throw error;
		}
	}
};

export const findGroupOwnerSSN = async (SSN) => {
	try {
		const endpoint = `find-group-owner-ssn/${SSN}`;
		const response = await get(endpoint);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "SSN doesnot exists!") {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "SSN is required") {
				alert("SSN is required");
			} else if (message === "SSN already exists!") {
				alert("SSN already exists!");
			} else if (message === MESSAGE.get.fail) {
				if (ADMIN_ENV == "DEV") {
					console.log("Failed to fetch data");
				} else {
					alert("Failed to fetch data");
				}
			} else {
				if (ADMIN_ENV == "DEV") {
					console.log("Failed to fetch data");
				} else {
					alert("Failed to fetch data");
				}
			}
		} else {
			throw error;
		}
	}
};

// Finding SSN with the help of Query
export const findMemberSSN = async (findSSNQuery) => {
	try {
		const endpoint = "find-member-ssn";
		const response = await get(endpoint, {}, findSSNQuery);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "SSN doesnot exists!") {
				const {
					data: { result }
				} = response;
				return result;
			} else if (message === "SSN already exists!") {
				const {
					data: { result }
				} = response;
				alert("SSN already exists!");
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log("Failed to fetch data");
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			throw error;
		}
	}
};

export const checkPersonAlreadyExists = async (query) => {
	try {
		const endpoint = "search-person-identity";

		const response = await get(endpoint, {}, query);

		if (!response || !response.data) {
			return {
				personExists: false,
				relationships: []
			};
		}

		const { person_exists, person, dependentAlreadyExistsForEmployee, relationships } = response.data;

		return {
			personExists: person_exists,
			person: person || null,
			relationships: relationships || [],
			dependentAlreadyExistsForEmployee: dependentAlreadyExistsForEmployee
		};
	} catch (error) {
		if (ADMIN_ENV === "DEV") {
			console.error("[checkPersonAlreadyExists]", error);
		}
		return {
			personExists: false,
			relationships: []
		};
	}
};

export const findLocation = async (findLocationQuery) => {
	try {
		const endpoint = "find-location";
		const response = await get(endpoint, {}, findLocationQuery);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "Location Number doesnot exists!") {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log("Failed to fetch data");
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log("Failed to fetch data");
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			throw error;
		}
	}
};

export const find = {
	findEmail,
	findMemberEmail,
	findGroupOwnerEmail,
	findSSN,
	findUserName,
	findMemberId,
	findSSN,
	findMemberSSN,
	findGroupOwnerSSN,
	findLocation,
	checkPersonAlreadyExists
};
